.container {
  & button:last-child {
    border-color: var(--color-primary-crayola);
    color: var(--color-primary-crayola);

    &:hover,
    &:focus-visible {
      background-color: transparent;
    }
  }
}

.separator-with-word {
  display: flex;
  flex-direction: row;

  &:before,
  &:after {
    content: '';
    flex: 1 1;
    border: 1px solid var(--color-grey-8);
    margin: auto;
  }

  span {
    padding: 0 1.6rem;
    font-size: 1.4rem;
    font-weight: 400;
    color: var(--color-grayscale-white);
  }
}
